import { clsx } from 'clsx';
import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import {
  avatarGroup,
  avatarGroupContainer,
  additionalInfo,
} from './avatar-group.css.ts';

interface AvatarGroupProps extends ComponentPropsWithoutRef<'div'> {
  label?: ReactNode | string;
}

export const AvatarGroup: FC<AvatarGroupProps> = ({
  className,
  children,
  label,
}) => {
  return (
    <div className={clsx(avatarGroupContainer, className)}>
      <div className={avatarGroup}>{children}</div>
      {label ? <span className={additionalInfo}>{label}</span> : null}
    </div>
  );
};
